const radio = [
    {
        name :"On Thyroid",
        yes :"Yes",
        no : "No",
        key:1
    },
    {
        name:"On Antithyroid Medication",
        yes :"Yes1",
        no : "No1",
        key:2
    },
    {
        name:"Sick",
        yes :"Yes2",
        no : "No2",
        key:3
    },
    {
        name:"Pregnant",
        yes :"Yes3",
        no : "No3",
        key:4
    },
    {
        name:"Thyroid Surgery",
        yes :"Yes4",
        no : "No4",
        key:5
    },
    {
        name:"I131 Treatment",
        yes :"Yes5",
        no : "No5",
        key:6
    },
    {
        name:"Tumor",
        yes :"Yes7",
        no : "No7",
        key:8
    },
    
    {
        name:"Psych",
        yes :"Yes9",
        no : "No9",
        key:10
    },
    {
        name:"Query On Thyroxine",
        yes: "yes10",
        no: "no10",
        key:11
    },
    {
        name:"Query Hypothyroid",
        yes: "yes11",
        no: "no11",
        key:12
    },
    {
        name:"Query Hyperthyroid",
        yes: "yes12",
        no: "no12",
        key:13
    },
];

export default radio;